import { apiRequest } from './api';

export const foodBeverageApi = {
  getQrHotels: () => apiRequest('/qr/hotels/'),
  createQrHotel: (payload) => apiRequest('/qr/hotels/', 'POST', payload),
  updateQrHotel: (id, payload) => apiRequest(`/qr/hotels/${id}/`, 'PUT', payload),
  deleteQrHotel: (id) => apiRequest(`/qr/hotels/${id}/`, 'DELETE'),
  translateQrHotel: (id) => apiRequest(`/qr/hotels/${id}/translate/`, 'POST'),
  translateQrHotelMissing: (id) => apiRequest(`/qr/hotels/${id}/translate-missing/`, 'POST'),

  getProductGroups: (qrHotelId = null) =>
    apiRequest(`/qr/product-groups/${qrHotelId ? `?qr_hotel_id=${qrHotelId}` : ''}`),
  createProductGroup: (payload) => apiRequest('/qr/product-groups/', 'POST', payload),
  updateProductGroup: (id, payload) => apiRequest(`/qr/product-groups/${id}/`, 'PUT', payload),
  deleteProductGroup: (id) => apiRequest(`/qr/product-groups/${id}/`, 'DELETE'),
  translateProductGroup: (id) => apiRequest(`/qr/product-groups/${id}/translate/`, 'POST'),

  getAreas: (qrHotelId = null) =>
    apiRequest(`/qr/areas/${qrHotelId ? `?qr_hotel_id=${qrHotelId}` : ''}`),
  createArea: (payload) => apiRequest('/qr/areas/', 'POST', payload),
  updateArea: (id, payload) => apiRequest(`/qr/areas/${id}/`, 'PUT', payload),
  deleteArea: (id) => apiRequest(`/qr/areas/${id}/`, 'DELETE'),
  translateArea: (id) => apiRequest(`/qr/areas/${id}/translate/`, 'POST'),
  /** Copy all products from source_area_id into target area (same QR hotel). Appends rows. */
  copyAreaProducts: (targetAreaId, payload) =>
    apiRequest(`/qr/areas/${targetAreaId}/copy-products/`, 'POST', payload),
  getAreaQrCode: (areaId, options = {}) => {
    const params = new URLSearchParams();
    if (options.watermark) params.set('watermark', '1');
    const qs = params.toString();
    return apiRequest(`/qr/areas/${areaId}/qr-code/${qs ? `?${qs}` : ''}`);
  },
  getAreaQrCodeWithLogo: (areaId, logoFile, options = {}) => {
    const formData = new FormData();
    formData.append('logo', logoFile);
    if (options.watermark) formData.append('watermark', '1');
    return apiRequest(`/qr/areas/${areaId}/qr-code/`, 'POST', formData);
  },

  getProducts: (qrHotelId = null) =>
    apiRequest(`/qr/products/${qrHotelId ? `?qr_hotel_id=${qrHotelId}` : ''}`),
  createProduct: (payload) => apiRequest('/qr/products/', 'POST', payload),
  updateProduct: (id, payload) => apiRequest(`/qr/products/${id}/`, 'PUT', payload),
  deleteProduct: (id) => apiRequest(`/qr/products/${id}/`, 'DELETE'),
  translateProduct: (id) => apiRequest(`/qr/products/${id}/translate/`, 'POST'),
  /**
   * Bulk: fill missing en/de/ru for products (optional qr_hotel_id).
   * opts: { offset, limit, onlyWithMissing } — sayfalama; onlyWithMissing false = tüm satırları tara (çoğu zaten dolu olabilir).
   */
  translateProductsMissing: (qrHotelId = null, opts = {}) => {
    const params = new URLSearchParams();
    if (qrHotelId != null && qrHotelId !== '') params.set('qr_hotel_id', String(qrHotelId));
    if (opts.offset != null) params.set('offset', String(opts.offset));
    if (opts.limit != null) params.set('limit', String(opts.limit));
    if (opts.onlyWithMissing != null) params.set('only_with_missing', opts.onlyWithMissing ? '1' : '0');
    const qs = params.toString();
    return apiRequest(`/qr/products/translate-missing/${qs ? `?${qs}` : ''}`, 'POST');
  },
  /**
   * Bulk: fill missing en/de/ru only for product descriptions (optional qr_hotel_id).
   * opts: { offset, limit, onlyWithMissing }
   */
  translateProductDescriptionsMissing: (qrHotelId = null, opts = {}) => {
    const params = new URLSearchParams();
    if (qrHotelId != null && qrHotelId !== '') params.set('qr_hotel_id', String(qrHotelId));
    if (opts.offset != null) params.set('offset', String(opts.offset));
    if (opts.limit != null) params.set('limit', String(opts.limit));
    if (opts.onlyWithMissing != null) params.set('only_with_missing', opts.onlyWithMissing ? '1' : '0');
    const qs = params.toString();
    return apiRequest(`/qr/products/descriptions/translate-missing/${qs ? `?${qs}` : ''}`, 'POST');
  },
};

export default foodBeverageApi;
